/*
 * @Author: 刘小博
 * @Date: 2023-02-17 18:10:58
 * @LastEditTime: 2023-02-17 18:14:57
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\agreement-manage\year-agreement-manage\modules\yearAgreementRouter.js
 * 年度协议
 */
const yearAgreementRouter = [
  // 协议管理  年度协议
  {
    path: '/protocolManagement/annual-agreement/:id',
    name: 'protocolManagementAnnualAgreement',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/list.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '',
    },
  },
  // 协议管理  年度协议 新增|编辑
  {
    path: '/protocolManagement/annual-agreement/edit/:agreement_order/:crm_agreement_id',
    name: 'protocolManagementAnnualAgreementEdit',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/edit.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '',
      breadcrumb: [
        {
          title: '年度协议',
          name: 'protocolManagementAnnualAgreement',
        },
      ],
    },
  },
  // 协议管理  年度协议 详情
  {
    path: '/protocolManagement/annual-agreement/details/:agreement_order/:crm_agreement_id',
    name: 'protocolManagementAnnualAgreementDetails',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/details.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '详情',
      breadcrumb: [
        {
          title: '年度协议',
          name: 'protocolManagementAnnualAgreement',
        },
      ],
    },
  },
  // 协议管理  年度协议 日志
  {
    path: '/protocolManagement/annual-agreement/log/:agreement_order/:crm_agreement_id',
    name: 'protocolManagementAnnualAgreementLog',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/log.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '操作日志',
      breadcrumb: [
        {
          title: '年度协议',
          name: 'protocolManagementAnnualAgreement',
        },
      ],
    },
  },
  // 协议管理  年度协议 批量导入
  {
    path: '/protocolManagement/annual-agreement/batch-import/:agreement_order',
    name: 'protocolManagementAnnualAgreementBatchImport',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/batchImport.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '批量导入',
      breadcrumb: [
        {
          title: '年度协议',
          name: 'protocolManagementAnnualAgreement',
        },
      ],
    },
  },
  // 协议管理  年度协议 批量更新
  {
    path: '/protocolManagement/annual-agreement/batch-update/:agreement_order',
    name: 'protocolManagementAnnualAgreementBatchUpdate',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapCommercialSalesData" */
        '@/views/protocolManagement/annualAgreement/batchUpdate.vue'
      ),
    meta: {
      SecondaryMenu: '年度协议', //二级菜单
      title: '批量更新',
      breadcrumb: [
        {
          title: '年度协议',
          name: 'protocolManagementAnnualAgreement',
        },
      ],
    },
  },
]
export default yearAgreementRouter
